<div class="row">
  <div class="col-sm-12">
    <label class="col-form-label" [ngClass]="{'requiredMark': validators.length > 0}"
      >Select Project:</label>
    <div>
      <!-- <dx-select-box
        [dataSource]="projectList"
        valueExpr="id"
        displayExpr="project_name"
        [searchEnabled]="true"
        [searchExpr]="['project_name']"
        [showClearButton]="true"
        [(value)]="value"
        (onSelectionChanged)="valueChanged($event)" 
      >
      <dx-validator [validationGroup]="validationGroupName" [validationRules]="validators"></dx-validator>

      </dx-select-box> -->
       <dx-tag-box
        class="col-sm-12"
        [items]="projectList"
        displayExpr="project_name"
        [searchEnabled]="true"
        [searchExpr]="['project_name']"
        [showSelectionControls]="true"
        [showDropDownButton]="true"
        selectAllMode="page"
        [maxDisplayedTags]="4"
        [showMultiTagOnly]="false"
        [value]="selectedProjects"
        [readOnly]="false"
        [wrapItemText]="true"
        [useItemTextAsTitle]="true"
       (onValueChanged)="projectOptionChange($event)"
      >
        <dx-validator [validationGroup]="validationGroupName">
          <dxi-validation-rule
            type="required"
            message="Project Required"
          >
          </dxi-validation-rule>
        </dx-validator>
      </dx-tag-box>
    </div>
  </div>
</div>